/* eslint-disable no-unused-vars */
import { Checkbox, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { addTransportColumnCheckedItem, deleteTransportColumnCheckedItem } from 'app/actions/map';
import { Protect } from 'app/components';
import { useLocalStorage } from 'app/services';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const MapTransportViewMenu = function (props) {
  const dispatch = useDispatch();
  const checkedItems = useSelector((state) => state.map.transportColumnCheckedItems);
  const { open, onClose, anchorEl } = props;
  const [, setCheckedStorageItems] = useLocalStorage('transportColumnCheckedItems', []);

  const handleClickItem = (value) =>
    dispatch(checkedItems.indexOf(value) !== -1 ? deleteTransportColumnCheckedItem(value) : addTransportColumnCheckedItem(value));

  useEffect(() => {
    setCheckedStorageItems(checkedItems);
  }, [checkedItems]);

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      PaperProps={{
        sx: (theme) => ({
          marginTop: theme.spacing(1.5),
          '&:before': {
            right: '10px',
          },
        }),
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={(theme) => ({
        '.MuiListItemIcon-root': {
          minWidth: '26px!important',
        },
        '.MuiCheckbox-root': {
          padding: theme.spacing(0),
          marginLeft: theme.spacing(0),
          svg: {
            fontSize: '18px',
          },
        },
      })}>
      {config.mapTransportColumns.slice(1).map((column, key) => (
        <Protect
          key={column.name}
          permissions={column.permissions}
          renderPermitted={() => (
            <MenuItem disableRipple onClick={() => handleClickItem(column.name)}>
              <ListItemIcon>
                <Checkbox size='small' edge='start' tabIndex={-1} disableRipple checked={checkedItems.indexOf(column.name) !== -1} />
              </ListItemIcon>
              <ListItemText>{column.label}</ListItemText>
            </MenuItem>
          )}
          renderForbidden={() => <React.Fragment />}
        />
      ))}
    </Menu>
  );
};

export default MapTransportViewMenu;
